module.exports = __webpack_public_path__ + "img/card3.5ce95852.png";